import React from "react";
import type { CmsContentElement } from "../../cmscontent.types";
import { DomElement, attributesToProps } from "html-react-parser";

export const CmsContent_Name_Img: CmsContentElement = [
  "img",
  (domNode: DomElement) => {
    return domNode ? (
      <img
        src={domNode?.attribs?.src || ""}
        alt={domNode?.attribs?.alt || ""}
        className="inline-image"
        {...(domNode.attribs ? attributesToProps(domNode.attribs) : {})}
      />
    ) : null;
  },
] as CmsContentElement;
